/**
* Visa 500 keyword universe — organized clusters powering the /visa/*
* pSEO surface (services × countries × intents × documents × long-tail).
*/

export const VISA_500_KEYWORDS = {
  core: [
    "ขอวีซ่าไทย", "รับทำวีซ่า", "บริษัทรับทำวีซ่า", "เอเจนซี่ทำวีซ่า",
    "ตัวแทนยื่นวีซ่า", "รับยื่นวีซ่า", "ปรึกษาวีซ่าไทย",
    "thailand visa agency", "thai visa service", "thailand visa consultant",
    "visa thailand for foreigner", "how to get thai visa",
    "ต่อวีซ่าไทย", "ขยายวีซ่าไทย", "extend thai visa", "visa extension bangkok",
    "เปลี่ยนประเภทวีซ่า", "change visa type thailand",
    "รายงานตัว 90 วัน", "90 day report thailand", "tm30", "tm47",
    "re-entry permit", "multi re-entry permit thailand",
    "รับทำวีซ่าด่วน", "urgent thai visa", "same day visa thailand",
    "ค่าบริการทำวีซ่า", "ราคาทำวีซ่า", "visa service fee thailand",
    "ตม.แจ้งวัฒนะ", "immigration chaengwattana", "one stop service visa",
    "work permit thailand", "ขอใบอนุญาตทำงาน", "wp3", "digital work permit",
    "visa on arrival thailand", "voa thailand", "e-visa thailand",
    "thai e-visa portal", "evisa.thaiembassy",
  ],
  services: [
    "วีซ่าท่องเที่ยว", "tourist visa thailand", "tr visa",
    "วีซ่าทำงาน non-b", "non b visa thailand", "business visa thailand",
    "วีซ่าแต่งงาน non-o", "marriage visa thailand", "non-o thai spouse",
    "วีซ่าเกษียณ", "retirement visa thailand", "non-o-a visa", "o-x visa",
    "smart visa thailand", "smart s smart t smart i smart e smart o",
    "elite visa", "thailand privilege visa", "tpc visa",
    "ltr visa", "long term resident visa thailand", "boi ltr",
    "dtv visa", "destination thailand visa", "digital nomad visa thailand",
    "วีซ่านักเรียน non-ed", "student visa thailand", "ed visa",
    "วีซ่าผู้ติดตาม", "dependent visa thailand", "non-o dependent",
    "permanent residence thailand", "pr thailand", "ถิ่นที่อยู่ถาวร",
    "boi visa section 24", "boi work visa", "boi e-visa",
  ],
  countries: [
    "วีซ่าอเมริกา", "us visa from thailand", "b1 b2 visa thailand",
    "วีซ่าอังกฤษ", "uk visa from thailand", "standard visitor visa",
    "วีซ่าออสเตรเลีย", "australia visa thailand", "subclass 600 500 482 189",
    "วีซ่าแคนาดา", "canada visa thailand", "trv canada", "biometrics thailand",
    "วีซ่าเชงเก้น", "schengen visa thailand", "eu visa bangkok",
    "วีซ่าเยอรมนี", "germany visa thailand", "vfs germany bangkok",
    "วีซ่าฝรั่งเศส", "france visa thailand", "tls france bangkok",
    "วีซ่าญี่ปุ่น", "japan visa thailand", "jvac bangkok",
    "วีซ่าจีน", "china visa thailand", "cvasc bangkok",
    "วีซ่าเกาหลี", "korea visa thailand", "kvac bangkok",
    "วีซ่าอินเดีย", "india visa thailand", "e-visa india",
    "วีซ่าดูไบ", "uae visa thailand", "dubai visa",
    "วีซ่าไต้หวัน", "taiwan visa thailand",
    "วีซ่าสิงคโปร์", "singapore visa thailand",
    "วีซ่านิวซีแลนด์", "new zealand visa thailand",
    "วีซ่าอิสราเอล", "israel visa thailand",
    "วีซ่ารัสเซีย", "russia visa thailand",
  ],
  intents: [
    "วีซ่าแต่งงานคนอเมริกัน", "k1 fiance visa thailand", "cr1 spouse visa",
    "วีซ่าติดตามลูก", "family reunion visa", "certificate of no impediment",
    "วีซ่าเรียนต่อ", "study abroad visa thailand",
    "วีซ่าทำงานต่างประเทศ", "work abroad visa", "skilled worker visa uk",
    "วีซ่าท่องเที่ยว 6 เดือน", "multi entry tourist visa",
    "วีซ่าเยี่ยมญาติ", "visit family visa",
    "วีซ่านักลงทุน", "investor visa", "e-2 visa", "innovator founder visa uk",
    "วีซ่าคู่หมั้น", "fiance visa thailand", "prospective marriage 300",
    "วีซ่าเกษียณต่างประเทศ", "retire abroad visa",
    "วีซ่าติดตามคู่สมรส", "spouse dependent visa",
    "วีซ่าคนไทยไปต่างประเทศ", "thai passport visa",
    "วีซ่าอังกฤษไปทำงาน", "uk sponsor licence",
  ],
  documents: [
    "หนังสือรับรองสถานะโสด", "single certificate", "cenomar thailand",
    "ใบตรวจประวัติอาชญากรรม visa", "police clearance for visa",
    "หนังสือรับรองการทำงาน visa", "employment certificate visa",
    "bank statement visa", "affidavit of support",
    "บัญชีเงินฝาก 800,000 บาท retirement",
    "บัญชีเงินฝาก 400,000 บาท marriage",
    "เอกสารประกอบวีซ่า", "visa document checklist",
    "รับรองเอกสารสถานทูต visa", "notary + mfa + embassy for visa",
    "แปลเอกสารยื่นวีซ่า", "certified translation visa",
    "ใบรับรองแพทย์ visa", "medical certificate visa",
  ],
  process: [
    "ขั้นตอนยื่นวีซ่า", "visa application steps",
    "จองคิววีซ่า", "vfs appointment", "tls appointment",
    "สัมภาษณ์วีซ่า", "visa interview tips",
    "เอกสารยื่นวีซ่า", "visa document list",
    "ระยะเวลาทำวีซ่า", "visa processing time",
    "ค่าธรรมเนียมวีซ่า", "visa fee 2026",
    "ถ่ายรูปวีซ่า", "visa photo requirements",
    "ยื่นวีซ่าออนไลน์", "online visa application",
    "ตรวจสอบสถานะวีซ่า", "check visa status",
    "อุทธรณ์วีซ่าถูกปฏิเสธ", "visa refusal appeal",
    "เหตุผลวีซ่าถูกปฏิเสธ", "reasons for visa refusal",
    "reapply visa after refusal",
  ],
  compare: [
    "ltr vs elite visa", "elite vs dtv", "dtv vs smart visa",
    "non-o vs non-b", "non-o-a vs non-o-x",
    "tourist visa vs visa exempt", "voa vs e-visa",
    "boi vs work permit", "pr vs ltr",
  ],
} as const;

export const VISA_INTENTS: ReadonlyArray<{ slug: string; nameTh: string; nameEn: string; eta: string }> = [
  { slug: "urgent", nameTh: "รับทำวีซ่าด่วน / เร่งด่วน", nameEn: "Urgent Visa Service", eta: "3-7 วันทำการ" },
  { slug: "same-day-consult", nameTh: "ปรึกษาวีซ่าด่วน / วันนี้", nameEn: "Same-day Consultation", eta: "ภายใน 24 ชม." },
  { slug: "extend", nameTh: "ต่อวีซ่า / ขยายวีซ่า", nameEn: "Visa Extension", eta: "1-2 วันทำการ" },
  { slug: "change-type", nameTh: "เปลี่ยนประเภทวีซ่า", nameEn: "Change of Visa Status", eta: "2-4 สัปดาห์" },
  { slug: "90-day-report", nameTh: "รายงานตัว 90 วัน แทน", nameEn: "90-Day Report Filing", eta: "1 วันทำการ" },
  { slug: "tm30", nameTh: "แจ้ง TM30 ที่พักอาศัย", nameEn: "TM30 Filing", eta: "1 วันทำการ" },
  { slug: "re-entry", nameTh: "Re-Entry Permit", nameEn: "Re-Entry Permit", eta: "1 วันทำการ" },
  { slug: "work-permit", nameTh: "ยื่นใบอนุญาตทำงาน", nameEn: "Work Permit Application", eta: "5-10 วันทำการ" },
  { slug: "family", nameTh: "วีซ่าครอบครัว/ผู้ติดตาม", nameEn: "Family/Dependent Visa", eta: "3-4 สัปดาห์" },
  { slug: "appeal", nameTh: "อุทธรณ์วีซ่าถูกปฏิเสธ", nameEn: "Visa Refusal Appeal", eta: "2-6 สัปดาห์" },
] as const;
